import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CheckIcon, X } from 'lucide-react'

const MultiCheckboxGroup = ({
  name,
  options = [],
  selectedValues = [],
  onChange
}) => {
  const [localSelected, setLocalSelected] = useState(selectedValues)

  const handleChange = (value) => {
    const newSelected = localSelected.includes(value)
      ? localSelected.filter(item => item !== value)
      : [...localSelected, value]

    setLocalSelected(newSelected)

    // Disparar el evento para que tu handleChange lo procese
    const syntheticEvent = {
      target: {
        name,
        value: newSelected, // Envía el array completo
        type: 'checkbox-group'
      }
    }

    onChange(syntheticEvent)
  }

  const handleSelectAll = () => {
    const allValues = options.map(option => option.name)
    const newSelected = localSelected.length === options.length ? [] : allValues
    setLocalSelected(newSelected)

    const syntheticEvent = {
      target: {
        name,
        value: newSelected,
        type: 'checkbox-group'
      }
    }

    onChange(syntheticEvent)
  }

  return (
    <div className="multi-checkbox-group">
      <button
        type="button"
        onClick={handleSelectAll}
        className="select-all-btn"
      >
        <span style={{ marginRight: 8 }}>
          {localSelected.length === options.length ? 'Desmarcar todo' : 'Marcar todo'}
        </span>
        {localSelected.length === options.length
          ? <X className='redxmark' size={18} strokeWidth={5}/>
          : <CheckIcon className='greencheck' size={18} strokeWidth={5} />}
      </button>

      <div className="checkbox-container">
        {options.map((option) => (
          <label key={'tc-' + option.id} className="checkbox-label">
            <input
              name={name}
              type="checkbox"
              value={option.name}
              checked={localSelected.includes(option.name)}
              onChange={() => handleChange(option.name)}
            />
            <span>{option.name}</span>
          </label>
        ))}
      </div>
    </div>
  )
}

MultiCheckboxGroup.propTypes = {
  options: PropTypes.arrayOf.isRequired,
  selectedValues: PropTypes.arrayOf.isRequired,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired
}

export { MultiCheckboxGroup }
